(function(){
    'use strict';

/**
* @memberof app
* @ngdoc controller
* @name HomeController
* @description
* This is main controller
**/ 
    angular.module('app')
    //Controlador('parametro nombre controlador', 'funcion controlador')
    .controller('ResultsController', ResultsController);

    ResultsController.$inject = ["PostsService"];

    function ResultsController(PostsService)
    {
        var vm = this;



        vm.arrayFinal = [];
        vm.loading = false;
        vm.pagina = 0;
        vm.emptyarray = false;
        vm.totalItems = 0;
        vm.limit = 15;
        vm.increamented = 1;

        vm.loadResults= function(){
               vm.loading =true;
                PostsService.searchPage(vm,function(data){
                    vm.arrayFinal = data.arrayFinal;
                    vm.totalItems = data.items;
                    vm.loading = false;

                    if (vm.totalItems <=15) {

                        vm.emptyarray = true;
                    }
                    vm.loadMore = function() {
                      
                      vm.increamented = vm.limit + 15;
                      vm.limit = vm.incremented > vm.arrayFinal.length ? vm.arrayFinal.length : vm.increamented;
                      if (vm.increamented >= vm.totalItems) {
                         vm.emptyarray = true;
                         //console.log(vm.emptyarray);
                      }


                    };
              })
           
        }
    }

})();

